import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';

import Svg from '@styles/icons/svg';
import { font } from '@styles/fonts';

export default ({ C, data }) => {
  return (
    <View
      style={{
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: scale(50),
      }}
    >
      <Svg icon="tick" width={scale(48)} height={scale(48)} color="System/Light/Green" />
      <Text style={[font['Headline'], { color: C('Label/Light/Primary'), marginTop: scale(10) }]}>{i18n.t('Machine Connection Successful')}</Text>
      <View
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: scale(34),
        }}
      >
        <Text style={[font['Body'], { color: C('Label/Light/Tertiary') }]}>{i18n.t('Connected to')}</Text>
        <Text style={[font['Body'], { color: C('Label/Light/Tertiary') }]}>{data.endpoint}</Text>
      </View>
      <View
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: scale(34),
        }}
      >
        <Text style={[font['Body'], { color: C('Label/Light/Tertiary') }]}>{data.machineBrandName}</Text>
        <Text style={[font['Body'], { color: C('Label/Light/Tertiary') }]}>
          {i18n.t('with')} {data.connectionMethodCode}
        </Text>
      </View>
      <View
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: scale(50),
        }}
      >
        <Text style={[font['Body'], { color: C('Label/Light/Tertiary') }]}>{i18n.t('Running')}</Text>
        <Text style={[font['Body'], { color: C('Label/Light/Tertiary') }]}>{data.ncFile}</Text>
      </View>
    </View>
  );
};
